module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-pers",
    attrs: {
      "id": "pers-tab5",
      "name": "hres32e-tab5"
    }
  }, [_c('div', {
    staticClass: "card-ui card-ui-center clearfix border-top-color-skin"
  }, [_c('div', {
    staticClass: "sub-topic-box clearfix",
    on: {
      "click": _vm.toggleSubTopic1
    }
  }, [_c('i', {
    staticClass: "fa fa-user icon-sub-topic",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sub-topic"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC1']['100']))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subTopic1),
      expression: "subTopic1"
    }],
    staticClass: "data-box clearfix"
  }, [_c('div', {
    staticClass: "data-row"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC11']['10']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('hrms-dropdown', {
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "options": _vm.arrTyprewd[_vm.nowLang]
    },
    model: {
      value: (_vm.detail.typrewd),
      callback: function($$v) {
        _vm.$set(_vm.detail, "typrewd", $$v)
      },
      expression: "detail.typrewd"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC11']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.numhmref),
      expression: "detail.numhmref"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:16'),
      expression: "'max:16'"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "id": "numhmref",
      "name": "numhmref",
      "maxlength": "16",
      "data-vv-name": "numhmref",
      "data-vv-as": "numhmref",
      "has-error": _vm.errors.has('numhmref')
    },
    domProps: {
      "value": (_vm.detail.numhmref)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "numhmref", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('numhmref')),
      expression: "errors.has('numhmref')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('numhmref')))])])]), _vm._v(" "), _c('div', {
    staticClass: "data-row"
  }, [_c('div', {
    staticClass: "col-xs-5 data-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES32EC11']['20']))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 data-input"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.desrewd1),
      expression: "detail.desrewd1"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:150'),
      expression: "'max:150'"
    }],
    staticClass: "form-control textarea-text",
    attrs: {
      "id": "desrewd1",
      "name": "desrewd1",
      "maxlength": "150",
      "data-vv-name": "desrewd1",
      "data-vv-as": "desrewd1",
      "has-error": _vm.errors.has('desrewd1')
    },
    domProps: {
      "value": (_vm.detail.desrewd1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "desrewd1", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('desrewd1')),
      expression: "errors.has('desrewd1')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('desrewd1')))]), _vm._v(" "), _c('div', {
    staticClass: "remark-limit-character"
  }, [_vm._v(_vm._s(_vm.dispLimitLabel(150)))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 box-footer"
  }, [(_vm.validateStaappr) ? _c('button', {
    staticClass: "btn bg-color-skin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.callSave()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v(_vm._s(_vm.labelsButton['save']))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn bg-dark-gray pull-left",
    attrs: {
      "type": "button",
      "value": "Back"
    },
    on: {
      "click": function($event) {
        _vm.togglePage(0)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left"
  }), _vm._v(_vm._s(_vm.labelsButton['back']))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3a88f138!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres32e/tab5.vue
// module id = 3693
// module chunks = 1